import { memo } from "react";
import { useOutlet } from "react-router-dom";
import { BottomNav } from "../navigation/BottomNav";

export const HomeLayout = () => {
	const outlet = useOutlet();

	return (
		<>
			<div className="max-w-md mx-auto">{outlet}</div>
			<MemoizedBottomNav />
		</>
	);
};

const MemoizedBottomNav = memo(BottomNav);
